export const MISC_BAR_HEIGHT = 30;
export const CATEGORY_BANNER_ID = "category-banner-wrapper";
export const CHROME_BREADCRUMB_ID = "chrome-breadcrumb";
export const SEARCH_TERM_ID = "search-term-banner";
export const VIDEO_HEADER = "video-header";
export const MOBILE_BREAKPOINT_WIDTH = 768;
export const MIN_SEO_LINKS = 2;
